import "@/plugins/axios.ts";
import "@/plugins/buefy.ts";
import "@/plugins/dayjs.js";
import "@/plugins/veevalidate.ts";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import moment from 'moment';
import VueMoment from 'vue-moment';
import ICS from 'vue-ics'

require('moment/locale/es');
moment.locale('es');

Vue.use(VueMoment, { moment });
Vue.use(ICS);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
